import { Button } from '@ui-components/neo.tax';

import {
  AnalysisType,
  EMAIL_TO_SUPPORT_URL,
  PageLayoutProps,
  useCurrentUserScopeForCurrentCompany,
  useUnfinishedSyncEventInPeriodByAnalysisType,
} from '@neo.tax/shared';

import { useSredContext } from '../context';

type PageLockStatus = {
  loading: boolean;
  pageLockStatus: Pick<PageLayoutProps, 'locked' | 'lockButtons' | 'lockedReason'>;
};

export const useSredPageLockStatus = ({
  disableIfOngoingSync,
}: { disableIfOngoingSync?: boolean } = {}): PageLockStatus => {
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();
  const { fiscalYear, fiscalYearId, periodName } = useSredContext();
  const { loading: loadingUnfinishedSyncEventsPeriod, period: unfinishedSyncEventsPeriod } =
    useUnfinishedSyncEventInPeriodByAnalysisType({ fiscalYearId, periodName, analysisType: AnalysisType.CaSred });

  if (loadingUnfinishedSyncEventsPeriod) {
    return {
      loading: true,
      pageLockStatus: {
        locked: false,
      },
    };
  }

  if (disableIfOngoingSync && unfinishedSyncEventsPeriod) {
    return {
      loading: false,
      pageLockStatus: {
        locked: true,
        lockedReason: 'Project Analysis is in progress. Please check back later.',
        lockButtons: (
          <Button size="xs" variant="white" rounded="regular" as="a" href={EMAIL_TO_SUPPORT_URL} target="_blank">
            Contact Support
          </Button>
        ),
      },
    };
  }

  if (!fiscalYear.lockedForCustomers) {
    return {
      loading: false,
      pageLockStatus: {
        locked: false,
      },
    };
  }

  if (limitAccessToFinancialData) {
    return {
      loading: false,
      pageLockStatus: {
        locked: true,
        lockedReason: 'It has been submitted for review. Please contact Neo.Tax admin if any changes need to be made.',
        lockButtons: (
          <Button size="xs" variant="white" rounded="regular" as="a" href={EMAIL_TO_SUPPORT_URL} target="_blank">
            Contact Support
          </Button>
        ),
      },
    };
  }

  return {
    loading: false,
    pageLockStatus: {
      locked: true,
      lockedReason: 'Review is in progress. Please contact Neo.Tax admin if any changes need to be made.',
      lockButtons: (
        <Button size="xs" variant="white" rounded="regular" as="a" href={EMAIL_TO_SUPPORT_URL} target="_blank">
          Contact Support
        </Button>
      ),
    },
  };
};
